import { render, staticRenderFns } from "./CallDraggable.vue?vue&type=template&id=f3a91550&scoped=true"
import script from "./CallDraggable.vue?vue&type=script&lang=js"
export * from "./CallDraggable.vue?vue&type=script&lang=js"
import style0 from "./CallDraggable.vue?vue&type=style&index=0&id=f3a91550&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a91550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3a91550')) {
      api.createRecord('f3a91550', component.options)
    } else {
      api.reload('f3a91550', component.options)
    }
    module.hot.accept("./CallDraggable.vue?vue&type=template&id=f3a91550&scoped=true", function () {
      api.rerender('f3a91550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/call-dialog/CallDraggable.vue"
export default component.exports